import * as React from 'react';
import { Typography, createStyles, withStyles, WithStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  link: {
    color: theme.palette.secondary.dark,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

interface IProps extends WithStyles<typeof styles> {
  children: React.ReactNode;
  url: string;
  target?: string;
  download?: boolean;
}

const Link: React.SFC<IProps> = ({ children, url, target, download, classes }: IProps) => {
  return (
    <Typography>
      <a href={url} target={target} className={classes.link} download={download}>
        {children}
      </a>
    </Typography>
  );
};

Link.defaultProps = {
  target: '_blank',
  download: false,
};

export default withStyles(styles)(Link);



// WEBPACK FOOTER //
// ./src/modules/shared/components/Link.tsx